export enum COMMON_SDK_EVENTS {
    WIDGET_INJECTED = "widgetInjected",
    WIDGET_OPENED = "widgetOpened",
    WIDGET_CLOSED = "widgetClosed",
}
